import React from "react";
import useTranslations from "../../../hooks/useTranslations";
import useUserLanguage from "../../../hooks/useUserLanguage";

const TablePagination = ({ table }) => {
    const { pageIndex, pageSize } = table.getState().pagination;
    const totalRecords = table.getPrePaginationRowModel().rows.length;
    const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize)); // **Minimum 1 sayfa**
    const language = useUserLanguage();
    const { translations } = useTranslations(language);
    const getText = (key, defaultValue) => translations[key] || defaultValue;

    // Başlangıç ve bitiş kayıtlarını hesapla
    const startRecord = totalRecords === 0 ? 0 : pageIndex * pageSize + 1;
    const endRecord = Math.min((pageIndex + 1) * pageSize, totalRecords);

    // **Sayfa numaralarını düzgün hesaplayan fonksiyon**
    const getPageNumbers = () => {
        const pages = [];
        
        if (totalPages <= 5) {
            for (let i = 0; i < totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(0); // İlk sayfa her zaman eklenir
            
            if (pageIndex > 2) pages.push("...");
            if (pageIndex > 1) pages.push(pageIndex - 1);
            
            if (pageIndex !== 0 && pageIndex !== totalPages - 1) {
                pages.push(pageIndex);
            }

            if (pageIndex < totalPages - 2) pages.push(pageIndex + 1);
            if (pageIndex < totalPages - 3) pages.push("...");
            
            pages.push(totalPages - 1); // Son sayfa her zaman eklenir
        }

        return pages;
    };

    return (
        <div className="row gy-2">
            <div className="col-sm-12 col-md-5 p-0">
                <div className="dataTables_info text-lg-start text-center">
                    {getText("TABLE_PAGINATION_INFO", "Toplam {total} kayıttan {start}-{end} arası gösteriliyor")
                        .replace("{total}", totalRecords.toLocaleString())
                        .replace("{start}", startRecord)
                        .replace("{end}", endRecord)
                    }
                </div>
            </div>
            <div className="col-sm-12 col-md-7 p-0">
                <div className="dataTables_paginate paging_simple_numbers">
                    <ul className="list-unstyled d-flex align-items-center gap-2 mb-0 pagination-common-style">
                        
                                 {/* İlk Sayfa */}
            <li className={`paginate_button page-item ${pageIndex === 0 ? "disabled" : ""}`}>
              <a
                href="#"
                className="page-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (pageIndex !== 0) table.setPageIndex(0);
                }}
              >
                «
              </a>
            </li>

            {/* Önceki */}
            <li className={`paginate_button page-item ${pageIndex === 0 ? "disabled" : ""}`}>
              <a
                href="#"
                className="page-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (pageIndex > 0) table.setPageIndex(pageIndex - 1);
                }}
              >
                {getText("TABLE_PAGINATION_PREV", "←")}
              </a>
            </li>

            {/* Sayfa Numaraları */}
            {getPageNumbers().map((p, i) => (
              <li
                key={i}
                className={`paginate_button page-item ${p === pageIndex ? "active" : ""} ${p === "..." ? "disabled" : ""}`}
              >
                {p === "..." ? (
                  <span className="page-link">…</span>
                ) : (
                  <a
                    href="#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      if (p !== pageIndex) table.setPageIndex(p);
                    }}
                  >
                    {p + 1}
                  </a>
                )}
              </li>
            ))}

            {/* Sonraki */}
            <li className={`paginate_button page-item ${pageIndex >= totalPages - 1 ? "disabled" : ""}`}>
              <a
                href="#"
                className="page-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (pageIndex < totalPages - 1) table.setPageIndex(pageIndex + 1);
                }}
              >
                {getText("TABLE_PAGINATION_NEXT", "→")}
              </a>
            </li>

            {/* Son Sayfa */}
            <li className={`paginate_button page-item ${pageIndex >= totalPages - 1 ? "disabled" : ""}`}>
              <a
                href="#"
                className="page-link"
                onClick={(e) => {
                  e.preventDefault();
                  if (pageIndex !== totalPages - 1) table.setPageIndex(totalPages - 1);
                }}
              >
                »
              </a>
            </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default TablePagination;
